import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, of, throwError} from 'rxjs';
import {catchError, mergeMap, shareReplay} from 'rxjs/operators';
import {ProjectService} from '../../../shared/services/project.service';
import {IEmailForm} from '../../../shared/interfaces/iemail-form';
import {INewsletterOtoForm} from '../../../shared/interfaces/inewsletter-oto-form';
import {EnvironmentService} from '../../../shared/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  constructor(private _http: HttpClient,
              private _environmentService: EnvironmentService,
              private _projectService: ProjectService) {
  }

  subscribeGeo(params: IEmailForm): Observable<any> {
    return forkJoin([
      this._projectService.getServiceKey(),
    ]).pipe(
      mergeMap(e => {
        const url = 'https://core2.offertetouroperator.com/~geo-thebox-proxy/dist/index.php/newsletter/iscrivi';

        return this._http.post<any>(url, {
          agenzia_id: e[0],
          nome: params.name,
          cognome: params.surname,
          email: params.email
        }).pipe(shareReplay({bufferSize: 1, refCount: true}));
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  subscribeNewsletterOTO(params: INewsletterOtoForm, selectedAgencyApikey?: string): Observable<any> {
    return forkJoin([
      this._projectService.getProject(),
      this._environmentService.getEnvironment(),
      this._projectService.getAgencyApikey()
    ]).pipe(
      mergeMap(e => {
        const [project, environment, agencyApikey] = e;
        const url = `${environment.otoApi2UrlDynamic}generic/nauth/${selectedAgencyApikey || agencyApikey}/newsletter/signup`;
        return this._http.post<any>(url, {
          externalId: params.externalAgencyId,
          name: params.name,
          surname: params.surname,
          marketingEmailConsent: 'Yes',
          marketingPhoneWithOperatorConsent: 'No',
          marketingPhoneWithoutOperatorConsent: 'No',
          marketingPaperConsent: 'No',
          profilingConsent: 'No',
          thirdPartyConsent: 'No',
          privacyConsent: 1,
          domain: project?.project?.domain,
          email: params.email,
          privacyPolicyText: "Newsletter"
        }).pipe(shareReplay({bufferSize: 1, refCount: true}));
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
